<script setup lang="ts">
import { NuxtError } from "nuxt/app";
import { isAuthError } from "@/types/AppErrorsCause";
import AppError from "./features/core-shared/components/AppError.vue";
import AppHeader from "./features/core-shared/components/AppHeader.vue";

interface Props {
  error: NuxtError;
}

const props = defineProps<Props>();

const showHeader = computed(() => !isAuthError(props.error.cause));
</script>

<template>
  <AppHeader v-if="showHeader" />
  <AppError :class="{ 'pb-(--header-height)': showHeader }" :error />
</template>
